module.exports = __webpack_public_path__ + "static/media/simulation-select-fixed-value.3148b6b2.svg";